/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsCart = {
  init: function ($section) {

    // Add settings from schema to current object
    //Shopify.theme.jsCart = $.extend(this, Shopify.theme.getSectionData($section));

    this.$section = $section;


    jQuery(".toggle-btn").change(function(){ 
          jQuery("#upload-photo").slideToggle('fast');
        });


    // Read a page's GET URL variables and return them as an associative array.
    function getUrlVars()
    {
        var vars = [], hash;
        var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
        for(var i = 0; i < hashes.length; i++)
        {
            hash = hashes[i].split('=');
            vars.push(hash[0]);
            vars[hash[0]] = hash[1];
        }
        return vars;
    }

    var urlView = getUrlVars()["view"];
    if(urlView) {
      if(urlView == 'add-laser-engraving') {
        $('#edit-engraving').show();
        $('#upload-photo').hide();
          $('#edit-duplication').hide();
        $('#cart-content').hide();
      }
      if(urlView == 'add-duplication') {
        $('#edit-duplication').show();
        $('#upload-photo').hide();
          $('#edit-engraving').hide();
        $('#cart-content').hide();
      }
      if(urlView == 'upload-photo') {
        $('#upload-photo').show();
          $('#edit-duplication').hide();
            $('#edit-engraving').hide();
        $('#cart-content').hide();
      }
    }

    $('#save-laser-engraving').on('click', function() {
        var inputVal = $('#laser-engraving-input').val();
        var variantID = $('#laser-engraving-input').attr('data-engraving-id');
        console.dir(inputVal);
        addLaserEngravingToCart(variantID, inputVal);
    });


 function addLaserEngravingToCart (variant_id, engraving_text) {

          data = {
        "id": variant_id,
        "quantity": 1,
        "properties": {
          "Engraving text": engraving_text
        }
      }


      jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function() {
            if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
            Shopify.theme.jsAjaxCart.updateView();
          }
             window.location.replace('/cart');
        }
      });

      }


      $('#save-duplication-product').on('click', function() {
        var variant_id = $('input[name="duplication_method"]:checked').attr('data-duplication-product-id');

        data = {
            "id": variant_id,
            "quantity": 1
          }

          jQuery.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: data,
            dataType: 'json',
            success: function() {
                Shopify.theme.jsAjaxCart.updateView();
                window.location.replace('/cart');
            }
          });

      });



    //edit cart line items


     $(document).on('click', 'span[data-line-item-edit]', function() {

       var data_cart_item_id = $(this).closest("div[data-cart-item]").attr('data-cart-item');

       var input_name = $(this).attr('data-line-item-edit');

       var input_to_append = $(this).parent().parent().parent().find("[data-item-property='"+ input_name + "']");

       var element_where_input_goes = $(this).parent().find('.line-item-p-last');
       var input_text_val = element_where_input_goes.text();
       input_to_append.val(input_text_val);

       console.dir('theValue' + input_text_val);

       //this is for the first input, before appended
       if ($(this).parent().hasClass('line-item-property__field')) {
         console.dir('here');
         $(this).parent().find(':input').removeClass('visibility-hidden');
          $(this).parent().find(':input').removeAttr('novalidate');
         var thistext = $(this).parent().find('.thetextvalue').text();
         $(this).parent().find(':input').val(thistext);
          $(this).parent().find('.thetextvalue').remove();
       }

       //append only the first time
      var has_been_appended =  $(this).parent().parent().find(':input').parent().hasClass('line-item-p-last');

      if(! has_been_appended) {
        console.dir('not has been appendded');
       element_where_input_goes.html("");
       input_to_append.appendTo($(this).parent().find('.line-item-p-last'));

     }else{
       console.dir('has_been_appended');
       input_to_append.removeClass('visibility-hidden');
       input_to_append.removeAttr('novalidate');
       input_to_append.parent().find('.thetextvalue').remove();

     }
     });

    var updateOldKeys = function (old_key,cart) {

          var line_item_value = $(".cart__card[data-cart-item='" + old_key + "']").attr('data-line-item');
            var new_key = cart.items[line_item_value - 1].key;


          $("[data-cart-item='" + old_key + "']").each(function() {
              var text = $(this).data('cart-item');
              // console.dir(text);
              //   console.dir($(this));

                //get new key based on data-line-item



                    $(this).attr('data-cart-item', new_key);
                  //  console.dir( $(this));

              // text = text.replace(text, old_key);

          });

           return new_key;
    }

    //forms in cart...ouch
     var save_cart_line_items = function (thisCartItem) {

      var inputValue = $(thisCartItem).val();
      var line_item_name = $(thisCartItem).attr('data-item-property');
      // console.dir(line_item_name);
      // console.dir('inputValue' + inputValue)
      // if(inputValue.trim() == ''){
      //   console.dir('no input' + line_item_name);
      //   inputValue = line_item_name;
      // }

                  $cart_item_key = $(thisCartItem).attr('data-cart-item');
                  //console.dir($cart_item_key);
                  $cart_item_property_to_update = $(thisCartItem).attr('data-item-property');

            $.ajax({
              type: 'GET',
              url: '/cart.js',
              dataType: 'json',
              success: function (cart) {
                //get item in cart by item key
               var index = cart.items.findIndex(function(item) {

                   return item.key == $cart_item_key;

                 });

                  // console.dir(cart.items[index]);
                  //   console.dir(cart.items[index].properties);
                  //   console.dir(cart.items[index].quantity);

                    var item__properties = cart.items[index].properties;

                    for (const [key, value] of Object.entries(item__properties)) {

                        if(key != $cart_item_property_to_update ) {
                          Object.assign(item__properties, {[$cart_item_property_to_update]: inputValue});

                        }
                      }

                    var item__properties = JSON.stringify(item__properties);
                    const old_key = cart.items[index].key;

                  // console.dir(cart.items[index]);
                  // console.dir('{"id":"'+ cart.items[index].key +'", "quantity":'+ cart.items[index].quantity+' , "properties":{ '+item__properties+'  }');
                  $.ajax({
                        url: "/cart/change.js",
                        type: "POST",
                        data: '{"id":"'+ cart.items[index].key +'", "quantity":'+ cart.items[index].quantity+' , "properties": '+item__properties+'  }',

                        contentType: "application/json",
                        dataType: 'json'

                  }).done(function() {

                    //now update the line item keys as they have changed on update

                    $.ajax({
                      type: 'GET',
                      url: '/cart.js',
                      dataType: 'json',
                      success: function (cart) {
                          // console.dir(cart.items);
                          // console.dir(old_key);
                          var new_key = updateOldKeys(old_key,cart);
                          //now update the html to reflext the save
                          console.dir('line_item_name'+line_item_name);
                          $("div[data-cart-item='"+new_key+"'] span[data-line-item-edit='" + line_item_name + "']").parent().find('.line-item-p-last .thetextvalue').remove();
                          $("div[data-cart-item='"+new_key+"'] span[data-line-item-edit='" + line_item_name + "']").parent().find('.line-item-p-last').append('<span class="thetextvalue">'+inputValue+'</span>');
                          var where_to_append = $("div[data-cart-item='"+new_key+"'] p[data-line-item-property='"+line_item_name+"']");
                            where_to_append.find('.thetextvalue').remove();
                              where_to_append.find('.edit-input').remove();
                          if(inputValue){
                            //hide og input
                            console.dir('has input value');
                            $("div[data-cart-item='"+new_key+"'] span[data-line-item-edit='" + line_item_name + "']").parent().find(':input').addClass('visibility-hidden');
                            $("div[data-cart-item='"+new_key+"'] span[data-line-item-edit='" + line_item_name + "']").parent().find(':input').attr('novalidate', 'novalidate');
                            where_to_append.append('<span class="thetextvalue">'+inputValue+'</span>');
                              where_to_append.find(':input').addClass('visibility-hidden');
                              where_to_append.find(':input').attr('novalidate', 'novalidate');
                              where_to_append.append('<span data-line-item-edit="'+line_item_name+'" class="edit-input">edit</span>');
                            console.dir(where_to_append);

                          }else{
                            //no value, move the input back

                            //append back to form area
                            $("div[data-cart-item='"+new_key+"'] span[data-line-item-edit='" + line_item_name + "']").parent().find(':input').appendTo(where_to_append);
                            where_to_append.removeClass("visibility-hidden");
                              where_to_append.find(':input').removeAttr('novalidate');


                        $("div[data-cart-item='"+new_key+"'] span[data-line-item-list-item='" + line_item_name + "']").remove();

                          }
                            // input_to_append.addClass('is-hidden');
                      }

                  });


                  });

                     }
             });


        // }else{
        //   console.dir('no value');
        // }
    }

    $(document).on('focusout', 'input[data-save]', function() {
  
      var thisCartItem = $(this);

      var inputValue = thisCartItem.val();

      if(inputValue.trim() !== ''){
         save_cart_line_items(thisCartItem);
       } else {
         if(thisCartItem.hasClass('input-required')) {
           thisCartItem.attr('required', 'required');
           thisCartItem.removeAttr('novalidate');
         }
       }

});

    $(document).on('change', 'select[data-save]', function() {
      var thisCartItem = $(this);
      var inputValue = thisCartItem.val();

      if(inputValue.trim() !== ''){
        save_cart_line_items(thisCartItem);
      } else {
        if(thisCartItem.hasClass('input-required')) {
          thisCartItem.attr('required', 'required');
          thisCartItem.removeAttr('novalidate');
        }
      }
    });

    $('.save-engraving').on('click', function() {
      // console.log("CLICK!");
      const $this = $(this);
      // console.dir($this);
      $cart_item_key = $this.closest('.cart__card').attr('data-cart-item');
        // console.dir(  $cart_item_key);
      $lazer_engraving_text = $this.closest('.cart__card').find('input[name="properties[Lazer Engraving]"]').val();
      //   console.dir($lazer_engraving_text);
      //
      // console.dir($cart_item_key);

      $.ajax({
        type: 'GET',
        url: '/cart.js',
        dataType: 'json',
        success: function (cart) {
          //get item in cart by item key
         var index = cart.items.findIndex(function(item) {
             return item.key == $cart_item_key;
           });

            // console.dir(cart.items[index]);
            // console.dir('{"id":"'+ cart.items[index].key +'", "quantity": 1, "properties":{ "Someprop": "Somevalue" } }');
            $.ajax({
                  url: "/cart/change.js",
                  type: "POST",
                  data: '{"id":"'+ cart.items[index].key +'", "quantity": 1, "properties":{ "Lazer Engraving": "'+$lazer_engraving_text+'" } }',
                  contentType: "application/json",
                  dataType: 'json'

            }).done(function() {

            });

         }


 });
      // $.ajax({
      //   type: 'GET',
      //   url: '/products/lazer-engraving.js',
      //   dataType: 'json',
      //   success: function (product) {
      //     console.dir(product);
      //     console.dir(product.variants[0].id);
      //       var prod_title = cart.items[index].product_title +'-'+ cart.items[index].variant_title;
      //       Shopify.theme.jsAjaxCart.addEngraveToCart(product.variants[0].id, prod_title, 'engrave text');
      //
      //
      //   },
      //   error: function (XMLHttpRequest, textStatus) {
      //     var response = eval('(' + XMLHttpRequest.responseText + ')');
      //     response = response.description;
      //
      //   }
      // });


      //var inputData = $this.closest('.propContainer').find('.propLine')

      // var data = {
      //    line: dataIndex,
      //    properties: ''
      //  }
      // var tempProperties = {}
      // inputData.each(function(index, el) {
      //   tempProperties[$(el).data('name')] = $(el).val();
      // });
      // data.properties = tempProperties;
      //
      // jQuery.ajax({
      //   url: '/cart/change.js',
      //   dataType: 'json',
      //   data: data
      // }).done(function() {

      // })
    });


// remove item from cart__tos
    $(document).on('click', '[data-cart-page-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).data('line-item-key');

      // engraving upcharge product
      const relatedParentID = $(this).data('cart-parent-item-key');

      // product with engraving
      const hasRelatedChild = $(this).data('is-engraving-parent');

      if(relatedParentID){
         //upcharge engraving product clicked, remove it and remove 'engraving' line item property from associated parent product
          console.dir(relatedParentID);
              console.dir(lineID);

              //update parent item -- remove line item property
              $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: {
                   "id": relatedParentID,
                  "properties": { '_': true }
                 },
                dataType: 'json',
                success: function(cart) {
                  // now remove  item clicked
                  Shopify.theme.jsCart.removeFromCart(lineID);
                  //  Shopify.theme.jsCart.updateView(cart);


                },
                error: function (XMLHttpRequest, textStatus) {
                  var response = eval('(' + XMLHttpRequest.responseText + ')');
                  response = response.description;
                  console.dir(response);
                }
              });








          return false;
      }

      if(hasRelatedChild){
        // item has a related charge -- engraving.  if item with engraving is removed, remove engraving product as well
        const thisCartItemKey = $(this).data('cart-item-key');

        const relatedChild = $('.cart__form').find("[data-cart-card-parent-item-key='"+thisCartItemKey+"']");

        const relatedChildCartItem = relatedChild.data('cart-item');

        const $cartItem = Shopify.theme.jsCart.$section.find(`[data-cart-item="${thisCartItemKey}"]`);

        $cartItem.css('opacity', '0.5');

        //remove item clicked
        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          data: 'quantity=0&id=' + thisCartItemKey,
          dataType: 'json',
          success: function (cart) {

            if(typeof relatedChildCartItem == 'undefined') {
              // no related item found, remove only item clicked
              $cartItem.addClass('animated zoomOut')
              $cartItem.remove();

              Shopify.theme.jsCart.updateView(cart);

              if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
                Shopify.theme.jsAjaxCart.updateView();
              }
            }

            if(typeof relatedChildCartItem !== 'undefined') {
              // has related item, remove it as well
              $.ajax({
                type: 'POST',
                url: '/cart/change.js',
                data: 'quantity=0&id=' + relatedChildCartItem,
                dataType: 'json',
                success: function (cart) {
                  $cartItem.addClass('animated zoomOut')
                  $cartItem.remove();

                  Shopify.theme.jsCart.updateView(cart);

                  if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
                    Shopify.theme.jsAjaxCart.updateView();
                  }
                }})
            }
          }})

          return false;
      }



      //remove normal item clicked
      Shopify.theme.jsCart.removeFromCart(lineID);

      return false;
    });

    // Prevent the ajax cart form from being submitted when pressing the "Enter" key
    $('#cart_form').keydown(function(e){
      if (e.keyCode == 13) {
        e.preventDefault();
        return false;
      }
    });
  },



  removeFromCart: function (lineID) {
    const $cartItem = Shopify.theme.jsCart.$section.find(`[data-line-item="${lineID}"]`);

    $cartItem.css('opacity', '0.5');


    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {

        $cartItem.addClass('animated zoomOut')
        $cartItem.remove();

        Shopify.theme.jsCart.updateView(cart, lineID);

        if (typeof Shopify.theme.jsAjaxCart !== 'undefined') {
          Shopify.theme.jsAjaxCart.updateView();
        }
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;
      }
    });
  },
  updateView: function (cart, lineID) {

    if (cart.item_count > 0) {
      $.ajax({
        dataType: "json",
        async: false,
        cache: false,
        dataType: 'html',
        url: "/cart",
        success: function (html) {

          if (lineID !== null) {

            const updatedItems = $(html).find('.cart__item-list .cart__card');
            const currentItems = $('.cart__item-list .cart__card');

            // Checks if BOGO applied and there is a change in the number of line items
            if (updatedItems.length != currentItems.length){
              const updatedCartList = $(html).find('.cart__item-list');
              // Re-append cart items
              $('.cart__item-list').replaceWith(updatedCartList);
            }

            $(currentItems).each(function(index, element){
              $(element).attr('data-line-item', (index + 1));
              $(element).find('[data-line-item-key]').attr('data-line-item-key', (index + 1));
            })

            const itemTotal = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__total');
            const quantityInput = $(html).find(`[data-line-item="${lineID}"]`).find('.quantity-input');
            const itemPrice = $(html).find(`[data-line-item="${lineID}"]`).find('.cart__price');

            $(`[data-line-item="${lineID}"]`).find('.cart__total').replaceWith(itemTotal);
            $(`[data-line-item="${lineID}"]`).find('.quantity-input').replaceWith(quantityInput);
            $(`[data-line-item="${lineID}"]`).find('.cart__price').replaceWith(itemPrice);

          }

          const subtotal = $(html).find('.cart__subtotal-container');
          const discounts = $(html).find('.cart__discounts');
          const savings = $(html).find('.cart__total-savings');

          $('.cart__subtotal-container').replaceWith(subtotal);

          if (discounts.length > 0 && $('.cart__discounts').length < 1) {
            $('.cart__subtotal-container').before(discounts);
          } else {
            $('.cart__discounts').replaceWith(discounts);
          }

          if (savings.length > 0 && $('.cart__total-savings').length < 1) {
            $('.cart__subtotal-container').after(savings);
          } else {
            $('.cart__total-savings').replaceWith(savings);
          }

          $('[data-bind="itemCount"]').text(cart.item_count);

        }
      });

    } else {
      $('.cart__empty-cart-message').removeClass('is-hidden');
      $('.cart__form').addClass('is-hidden');
      $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
      $('[data-bind="itemCount"]').text('0');
    }

  },
  unload: function ($section) {
    // Clear event listeners in theme editor
    $('[data-cart-page-delete]').off();
    $('#cart_form').off();
  }
}

/******/ })()
;
